import * as yup from "yup";

export const masterDataCreationSchema = yup.object().shape({
  article: yup.string().required("Article is required"),
  size: yup.string(),
  color: yup.string(),
  harga_acw: yup.number(),
  hpp: yup.number(),
  harga_internal: yup.number(),
  released_date: yup.date(),
});
